import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.keys";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import clsx from 'clsx';
/**
 * View is the container for any views provided by the explorer.
 * @param String displayView ID of view to display
 * @param Object children    Children (views)
 */

var View = function View(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  return /*#__PURE__*/React.createElement("div", {
    className: clsx("view-parent", props.className),
    "data-display": props.displayView
  }, children);
};

View.defaultProps = {};
export default View;